@if (payload) {
  @if (!payload.alphacount_configured) {
    <p class="notice">
      <nb-icon icon="alert-circle-outline"></nb-icon>
      <span>{{ "dialogs.contract.invoices.notConfigured" | translate }}</span>
    </p>
  }
  @if (missingFields.length) {
    <p class="notice">
      <nb-icon icon="alert-circle-outline"></nb-icon>
      <span>{{ "dialogs.contract.invoices.missingBilling" | translate: { fields: missingFields.join(", ") } }}</span>
    </p>
  }

  <!-- Naechste Rechnung -->
  <div class="block">
    <span class="label">{{ "dialogs.contract.invoices.next" | translate }}</span>
    @if (!contract?.billing_starts_on) {
      <p class="hint">{{ "dialogs.contract.invoices.noAutomatic" | translate }}</p>
    } @else if (next) {
      <p class="next-head">
        {{
          "dialogs.contract.invoices.nextOn"
            | translate
              : {
                  date: (next.date | date: "dd.MM.yyyy"),
                  kind: ("dialogs.contract.invoices.kinds." + next.kind | translate)
                }
        }}
      </p>
      @if (next.lines.length) {
        <ul class="lines">
          @for (line of next.lines; track $index) {
            <li>
              <span>{{ line.description }}</span>
              <span class="num">{{ line.amount_net_cents / 100 | currency: "EUR" }}</span>
            </li>
          }
          <li class="lines__total">
            <span>{{ "dialogs.contract.invoices.netTotal" | translate }}</span>
            <span class="num">{{ next.net_cents / 100 | currency: "EUR" }}</span>
          </li>
        </ul>
      } @else {
        <p class="hint">{{ "dialogs.contract.invoices.nextEmpty" | translate }}</p>
      }
      <p class="hint">{{ "dialogs.contract.invoices.nextHint" | translate }}</p>
    } @else {
      <p class="hint">{{ "dialogs.contract.invoices.noNext" | translate }}</p>
    }
  </div>

  <!-- Rechnungen -->
  <div class="block">
    <div class="list-head">
      <span class="label">{{ "dialogs.contract.invoices.title" | translate }}</span>
      <button nbButton size="small" status="basic" type="button" (click)="createManual()">
        <nb-icon icon="plus-outline"></nb-icon>
        <span>{{ "dialogs.contract.invoices.actions.create" | translate }}</span>
      </button>
    </div>

    @for (row of rows; track trackRow($index, row)) {
      <div class="row">
        <div class="row__main">
          <strong>{{ row.title }}</strong>
          <span class="chip chip--{{ row.tone }}">{{ "enums.contractInvoiceStatus." + row.invoice.status | translate }}</span>
          @if (row.invoice.dunning_level) {
            <span class="hint">{{ "dialogs.contract.invoices.dunningLevel" | translate: { level: row.invoice.dunning_level } }}</span>
          }
        </div>
        <div class="row__meta">
          @if (row.periodFrom) {
            <span>{{ row.periodFrom | date: "dd.MM.yyyy" }} – {{ row.periodTo | date: "dd.MM.yyyy" }}</span>
          }
          <span class="num">
            {{ row.invoice.net_cents / 100 | currency: "EUR" }} {{ "dialogs.contract.invoices.net" | translate }}
            @if (row.invoice.total_gross_cents != null) {
              · {{ row.invoice.total_gross_cents / 100 | currency: "EUR" }} {{ "dialogs.contract.invoices.gross" | translate }}
            }
          </span>
          @if (row.invoice.due_date) {
            <span>{{ "dialogs.contract.invoices.due" | translate: { date: (row.invoice.due_date | date: "dd.MM.yyyy") } }}</span>
          }
        </div>
        @if ((row.invoice.status === "failed" || row.invoice.status === "issued") && row.invoice.last_error) {
          <p class="row__error">{{ row.invoice.last_error }}</p>
        }
        <div class="row__actions">
          @if (row.canApprove) {
            <button nbButton size="tiny" status="primary" type="button" [disabled]="!!busyId" [nbSpinner]="isBusy(row, 'approve')" (click)="approve(row)">
              {{ (row.invoice.status === "issued" ? "dialogs.contract.invoices.actions.resend" : "dialogs.contract.invoices.actions.approve") | translate }}
            </button>
          }
          @if (row.canDiscard) {
            <button nbButton size="tiny" status="basic" type="button" [disabled]="!!busyId" [nbSpinner]="isBusy(row, 'discard')" (click)="discard(row)">
              {{ "dialogs.contract.invoices.actions.discard" | translate }}
            </button>
          }
          @if (row.canCancel) {
            <button nbButton size="tiny" status="basic" class="btn-caution" type="button" [disabled]="!!busyId" [nbSpinner]="isBusy(row, 'cancel')" (click)="cancel(row)">
              {{ "dialogs.contract.invoices.actions.cancel" | translate }}
            </button>
          }
          @if (row.invoice.has_pdf) {
            <button nbButton size="tiny" status="basic" type="button" [disabled]="!!busyId" [nbSpinner]="isBusy(row, 'pdf')" (click)="pdf(row)">
              <nb-icon icon="download-outline"></nb-icon>
              <span>PDF</span>
            </button>
          }
        </div>
      </div>
    } @empty {
      <p class="hint">{{ "dialogs.contract.invoices.empty" | translate }}</p>
    }
  </div>
}
